import { clients } from '@oncolens/oncolens-ui/lib/api/client';
import { PagedApiResponse, Pagination } from '@oncolens/oncolens-ui/lib/dto/api/ApiResponse';
import { AxiosResponse } from 'axios';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { QueryParams, UserDto } from '../types';
import { UserKeys } from './user.keys';

// eslint-disable-next-line @typescript-eslint/no-shadow
export async function getUsers(queryString: string) {
  // eslint-disable-next-line no-param-reassign, eqeqeq
  queryString = queryString == '' ? queryString : `?${queryString}`;

  return clients.admin.get(`/users${queryString}`).then((response: AxiosResponse<UserDto[]>) => {
    const { data } = response;

    return {
      data,
      pagination: JSON.parse(response.headers['x-pagination']) as Pagination,
    } as PagedApiResponse<UserDto>;
  });
}

export function useUserList({ pageNumber, pageSize, filters, sortOrder }: QueryParams) {
  const queryParams = queryString.stringify({
    pageNumber,
    pageSize,
    filters,
    sortOrder,
  });

  return useQuery(UserKeys.list(queryParams), () => getUsers(queryParams));
}
